import { useMutation, useQuery } from "@tanstack/react-query";

import { useRestApi } from "@/context/api";
import { useCurrentCompany } from "@/context/auth";
import { queryKeys } from "@/queries/queryKeys";

export const usePreviewStructureMutation = () => {
  const api = useRestApi();
  const currentCompany = useCurrentCompany();
  return useMutation({
    mutationFn: (file: File) =>
      api.structureImports.previewStructureImport(currentCompany.id, file),
  });
};

export const useApplyStructureMutation = () => {
  const api = useRestApi();
  const currentCompany = useCurrentCompany();
  return useMutation({
    mutationFn: (input: { file: File; digest: string; deleteEmptyTeams: boolean }) =>
      api.structureImports.applyStructureImport(
        currentCompany.id,
        input.file,
        input.digest,
        input.deleteEmptyTeams,
      ),
  });
};

export const useStructureBatchQuery = (batchId: string | undefined) => {
  const api = useRestApi();
  const currentCompany = useCurrentCompany();
  return useQuery({
    queryKey: [queryKeys.STRUCTURE_BATCH, currentCompany.id, batchId],
    queryFn: () =>
      api.structureImports.getStructureBatchStatus(currentCompany.id, batchId as string),
    enabled: !!batchId,
    refetchInterval: (query) => (query.state.data && query.state.data.pending > 0 ? 3000 : false),
  });
};

/** Where business units of existing users come from, which decides the sheets a structure file may use. */
export const useStructureImportModeQuery = () => {
  const api = useRestApi();
  const currentCompany = useCurrentCompany();
  return useQuery({
    queryKey: [queryKeys.STRUCTURE_IMPORT_MODE, currentCompany.id],
    queryFn: () => api.structureImports.getStructureImportMode(currentCompany.id),
  });
};
